export default {"src":"/_next/static/media/cinema-room.cd7d3ea1.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};